import styled from '@emotion/styled';

export const StyledSchemaContentFormLayout = styled('div')({
  padding: '24px',
});

export const StyledEditorWrap = styled('div')(({ theme }) => ({
  borderTop: `1px solid ${
    theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
  }`,
  minHeight: '70vh',
}));
